
import './App.scss';
import Card from './card/Card';

function App() {
  return (
    <div className="App">
 <Card/>
    </div>
  );
}

export default App;
